export const AcePortalClientTypes = [ 'AcePortal', 'AceHub' ];
